import { Container, Title, useMantineTheme, Group, Paper, Space } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { checkHealth } from '@store/features/health/healthSlice';
import { getAllContents } from '@store/features/content/contentSlice';
import { ContentTable } from '@components/ContentTable/ContentTable';
import { StatsSummary, LangPieChart, ContentTimeline } from '@components/features/Stats';
import styles from './Home.module.scss';
import { Grid } from '@mantine/core';

export const Home = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const isTablet = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const dispatch = useAppDispatch();
  const { status } = useAppSelector(state => state.health);
  const previousStatus = useRef<string | null>(null);

  // Función para volver a verificar el estado del sistema
  const handleRecheckHealth = () => {
    dispatch(checkHealth());
  };

  // Llamar al endpoint de salud al cargar el componente
  useEffect(() => {
    handleRecheckHealth();
  }, [dispatch]);

  // Efecto para cargar los contenidos cuando el estado del servidor cambia a "ok"
  useEffect(() => {
    // Si el estado anterior no era "ok" y ahora es "ok", cargar los contenidos
    if (previousStatus.current !== 'ok' && status === 'ok') {
      dispatch(getAllContents());
    }

    // Actualizar el estado anterior
    previousStatus.current = status;
  }, [status, dispatch]);

  return (
    <Container size={isTablet ? '100%' : 'xl'} px={isMobile ? 'xs' : 'md'}>
      <Group justify="space-between" align="center">
        <Title order={1} size={isMobile ? 'h2' : 'h1'}>
          {t('home.title')}
        </Title>
      </Group>

      <StatsSummary />

      <Grid gutter="md" mt="sm">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <LangPieChart />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <ContentTimeline />
        </Grid.Col>
      </Grid>

      <Space h="md" />

      <Paper shadow="sm" p="md" radius="md" withBorder className={styles.tableContainer}>
        <ContentTable />
      </Paper>
    </Container>
  );
};
